export const reviewers = [
    '',
    'Aditi',
    'Amy',
    'Carolyn',
    'Clara',
    'Debo',
    'Deon',
    'Doaa',
    'Emily',
    'Emma',
    'Ethan',
    'Evan',
    'Finnley',
    'Gabriel',
    'Ian',
    'Inaya',
    'Jake',
    'Jamie',
    'Jane J.',
    'Jane K.',
    'Jeffrey',
    'Joshua',
    'Jyothsna',
    'Khyati',
    'Michael',
    'Mika',
    'Mubeen',
    'Mira',
    'Oishika',
    'Olivia',
    'Qi',
    'Rémi',
    'Sebastian',
    'Shirley',
    'Sihan',
    'Siva',
    'Snigdha',
    'Sonia',
    'Stephanie',
    'Tavi',
    'Tina',
    'Vipul',
    'Yue Qian',
];

export const reviewerOptions = reviewers.map((reviewer) => ({
    label: reviewer,
    value: reviewer,
}));
